export default {"src":"/_next/static/media/wink.d9772061.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};